<template>
    <div class="scrollTop">
        <div class="layout-container">
            <button role="button" aria-label="Click to scroll to the top of the pagefff" class="button button--icon button--primary" @click="scrollToTop()" >
                <i class="icon icon-chevrondown" aria-hidden="true"></i>
            </button>
        </div>
    </div>
</template>

<script setup>
    const scrollToTop = () => {
      document.body.scrollTo({ top: 0, behavior: 'smooth' });
    };
</script>
